import * as React from 'react';

import { AgentContent } from './agent-content';
import { AgentHeader } from './agent-header';
import { AgentHeaderActions } from './agent-header-actions';
import { AgentLayout } from './agent-layout';
import { useConversationState } from './use-conversation-state';

export const AgentSidebar: React.FC = () => {
    const conversationState = useConversationState({
        variant: 'sidebar'
    });

    const headerActions = <AgentHeaderActions variant="sidebar" />;

    const header = (
        <AgentHeader headerActions={headerActions} showIntro={conversationState.showIntro} variant="sidebar" />
    );

    const content = <AgentContent state={conversationState} variant="sidebar" />;

    return <AgentLayout header={header} content={content} />;
};
